<template>
  <v-snackbar v-model="snackBar.open" flex :timeout="snackBar.time">
    <span class="message">{{ snackBar.msg }}</span>
    <v-btn icon color="white" text @click="closeSnackBar">
      <v-icon small>mdi-close</v-icon>
    </v-btn>
  </v-snackbar>
</template>

<script>
import { mapState, mapActions } from 'vuex'
export default {
  computed: {
    ...mapState(['snackBar']),
  },
  methods: {
    ...mapActions(['closeSnackBar']),
  },
}
</script>

<style scoped>
.v-snack ::v-deep .v-snack__content {
  display: flex;
  align-items: center;
  justify-content: space-between;
}
.message {
  font-weight: bold;
}
</style>
